import { EmploymentDetails } from '@kanda-libs/ks-frontend-services';

export const EMPLOYMENT_TYPE_FIELD_NAME: Record<
  Extract<EmploymentDetails['employment_status'], 'employed' | 'self_employed'>,
  string
> = {
  employed: 'employed_details.employer_address',
  self_employed: 'self_employed_details.business_address',
};

export const PRIMARY_BASE_FIELD_NAME = 'credit.employment_details';
